module.exports = {
  /* 01.General */
  "chat.end":"Aloita chat-keskustelu uudelleen",
  "chat.endall":"Lopeta keskustelu",
  "chat.cancel":"Peruuttaa",
  "chat.cookie":"Tämä digitaalinen avustaja käyttää evästeitä varmistaakseen, että saat parhaan käyttökokemuksen",
  "chat.learn":"Lue lisää",
  "chat.minimize":"Minimoida",
  "chat.hide":"kiinni",
  "chat.hidebot.text":"Sulje poistaa avatarin 15 minuutiksi",
  "chat.hidebot":"Sulje (Piilota) Avatar",
  "chat.restart":"Uudelleenkäynnistää",
  "switch.language":"Vaihda kieltä",
  "switch.property":"Vaihda omaisuutta",
  "restart.converstation":"Aloita keskustelu uudelleen",
  "chat.endtext":"Haluatko varmasti lopettaa nykyisen keskustelun?",
  "check.availabity":"Tarkista saatavuus",
  "check.availabity.submit":"Lähetä",
  "check.availabity.cancel":"Peruuttaa",
  "check.availabity.adults":"Aikuiset ",
  "check.availabity.children":"Lapset",
  "check.availabity.child.age":"Ikä - lapsi",
  "feedback.leave":"Jätä palautetta",
  "feedback.leave.message":"Jätä viesti",
};
